import {BackendAPITypes} from '../../../generated/blueprint';

export type BillDuplicateGroup = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetBillDuplicatesGetResponseBody;
export type BillDuplicate = BillDuplicateGroup['bills'][number];

export enum DuplicateDeleteAction {
    DELETE = 'delete',
    UNMATCH_AND_DELETE = 'unmatch_and_delete',
    BLOCKED = 'blocked',
}

export const BOOKED_DUPLICATE_CANNOT_BE_DELETED = 'Kan niet verwijderd worden: document is geboekt';

export function getDuplicateDeleteAction(bill: BillDuplicate): DuplicateDeleteAction {
    if (bill.is_booked) {
        return DuplicateDeleteAction.BLOCKED;
    }

    return bill.is_matched ? DuplicateDeleteAction.UNMATCH_AND_DELETE : DuplicateDeleteAction.DELETE;
}

export function remainingAfterDelete(group: BillDuplicateGroup, deletedBillId: string): BillDuplicate[] {
    return group.bills.filter((bill) => bill.bill_id !== deletedBillId);
}
